import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

import { deepEqual } from '../utils';
import * as lifeEvents from '../Driver/lifeEvents.types';
import { calculateAccWorkedDays, calculateWorkedDays } from '../Driver/helpers';

import Stat, { StatsWrapper } from '../Shared/UI/Stat';
import { Progress, ProgressWrapper } from '../Shared/UI/Progress';
import Box from '../Shared/UI/Box';

import Backend from '../Layouts/Backend';
// import Chart from '../Shared/Helpers/ChartBars';
import PageHeader from '../Shared/Helpers/PageHeader';

class DashboardPage extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  get summaryByCurrentLifeEventType() {
    const allCount = _.size(this.props.drivers);
    const countByType = _.countBy(this.props.drivers, 'currentLifeEvent.eventType');

    // mounting summary by each type
    const byType = {};
    _.forEach(lifeEvents.types, (type) => {
      const count = countByType[type] || 0;
      const percentage = (allCount === 0 || count === 0) ? 0 : _.round((count / allCount) * 100, 2);
      byType[type] = {
        count,
        percentage,
      };
    });

    // creating plus summaries like: all, available, unavailable
    const all = { count: allCount };
    const available = byType[lifeEvents.types.WORK];
    const unavailableCount = allCount - available.count;
    const unavailablePercentage = (allCount === 0 || unavailableCount === 0) ? 0 :
      _.round((unavailableCount / allCount) * 100, 1);
    const unavailable = {
      count: unavailableCount,
      percentage: unavailablePercentage,
    };

    // unavailable by type summary
    const unavailableByTypeMap = _.chain(byType)
      .map((typeSummary, type) => ({ type, data: typeSummary }))
      .filter(({ type }) => type !== lifeEvents.types.WORK)
      .value();

    const unavailableByType = _.chain(unavailableByTypeMap)
      .map(s => ({
        type: s.type,
        count: s.data.count,
        percentage: (allCount === 0 || s.data.count === 0) ? 0 :
          _.round((s.data.count / allCount) * 100, 1),
      }))
      .orderBy(['count'], ['desc'])
      .value();

    // high worked days summary - greater than 18 days
    const highWorkedDays = _.chain(this.props.drivers)
      .filter({ currentLifeEvent: { eventType: 'work' } })
      .countBy(driver => Math.floor(calculateWorkedDays(driver)))
      .filter((count, days) => Number(days) >= 18)
      .sum()
      .thru(count => ({
        count,
        percentage: (allCount === 0 || count === 0) ? 0 : _.round((count / allCount) * 100, 1),
      }))
      .value();

    // high acc worked days summary - greater than 18 days
    const highAccWorkedDays = _.chain(this.props.drivers)
      .filter({ currentLifeEvent: { eventType: 'work' } })
      .countBy(driver => Math.floor(calculateAccWorkedDays(driver)))
      .filter((count, days) => Number(days) >= 18)
      .sum()
      .thru(count => ({
        count,
        percentage: (allCount === 0 || count === 0) ? 0 : _.round((count / allCount) * 100, 1),
      }))
      .value();

    // continuous work
    const continuousWorkAverage = _.chain(this.props.drivers)
      .filter({ currentLifeEvent: { eventType: 'work' } })
      .map(calculateWorkedDays)
      .mean()
      .round(2)
      .value();

    // drivers with
    return {
      all,
      available,
      unavailable,
      unavailableByType,
      byType,
      highWorkedDays,
      highAccWorkedDays,
      continuousWork: { average: continuousWorkAverage },
    };
  }

  render() {
    const summary = this.summaryByCurrentLifeEventType;

    return (
      <Backend>
        <div className="content-inner no-padding-top no-padding-left no-padding-right">
          <PageHeader />

          <Box classes="border-bottom side-margins no-vertical-distance">
            <StatsWrapper>
              <Stat
                title="Motoristas Disponíveis"
                subtitle="Em trabalho neste momento"
                value={`${summary.available.count}`}
                label={`${summary.available.percentage}%`}
                /* labelClass={summary.available.percentage < 90 ? 'descreasing' : 'raising'} */
              />
              <Stat
                title="Indisponíveis"
                subtitle="Não estão a trabalho"
                value={`${summary.unavailable.count}`}
                label={`${summary.unavailable.percentage}%`}
                /* labelClass={summary.unavailable.percentage > 10 ? 'descreasing' : 'raising'} */
              />
              <Stat
                title="Em Acúmulo de Trabalho"
                subtitle="Acima de 18 dias trabalhados"
                value={`${summary.highAccWorkedDays.count}`}
                label={`${summary.highAccWorkedDays.percentage}%`}
                labelClass={summary.highAccWorkedDays.count > 0 ? 'descreasing' : 'raising'}
              />
              <Stat
                title="Em Trabalho Contínuo"
                subtitle="Acima de 18 dias trabalhando direto"
                value={`${summary.highWorkedDays.count}`}
                label={summary.highWorkedDays.percentage > 0 ? 'Ruim' : 'Bom'}
                labelClass={summary.highWorkedDays.count > 0 ? 'descreasing' : 'raising'}
              />
            </StatsWrapper>
          </Box>

          <Box title="Status de Indisponibilidades" classes="side-margins">
            <ProgressWrapper>
              {summary.unavailableByType.map(({ type, percentage, count }) => (
                <Progress
                  key={type}
                  size={percentage}
                  description={`${lifeEvents.humanizedNames[type]}: ${count} motorista(s)`}
                  showStatus
                />
              ))}
            </ProgressWrapper>
          </Box>

          {/* <Box title="Tempo Produzindo vs. Parado" classes="border-bottom side-margins">
            <Chart />
          </Box> */}

        </div>
      </Backend>
    );
  }
}

DashboardPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  drivers: PropTypes.object,
};

DashboardPage.defaultProps = {
  drivers: {},
};

const mapStateToProps = store => ({
  drivers: store.driverState.drivers,
});

export default connect(mapStateToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/DriversDashboardPage/DriversDashboardPage.js